const HeroText = () => {
  return (
    <div className="relative z-10 w-full min-h-[100dvh] flex flex-col justify-center px-4 sm:px-8 md:px-12 lg:px-20 xl:px-32 pt-0 md:pt-28 pointer-events-none">
      <div className="flex flex-col h-full md:h-auto min-h-[100dvh] md:min-h-0 justify-between md:justify-start items-center md:items-start w-full max-w-4xl lg:max-w-[70%] xl:max-w-[65%] pointer-events-auto pb-12 md:pb-0">

        {/* Text Group */}
        <div className="flex flex-col justify-center gap-12 md:gap-0 flex-grow md:flex-grow-0 md:block w-full">
          {/* Kicker */}
          <p className="hero-kicker font-medium tracking-[0.25em] text-blue-300/90 uppercase mb-0 sm:mb-4 md:mb-6 js-hero-item text-[clamp(0.7rem,1.5vw,1rem)] text-center md:text-left w-full">
            Yassine Essabir
          </p>

          {/* Main Headline */}
          <h1 className="hero-title mb-0 sm:mb-5 md:mb-8 js-hero-item text-center md:text-left w-full break-words text-balance leading-snug">
            ARCHITECTING <br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 via-purple-400 to-emerald-400">
              DIGITAL
            </span>{" "}
            <br />
            EXCELLENCE
          </h1>

          {/* Subline with separators */}
          <div className="hero-subline text-neutral-300 font-light tracking-wide js-hero-item flex flex-wrap gap-x-2 sm:gap-x-3 gap-y-1 items-center justify-center md:justify-start leading-relaxed w-full max-w-lg md:max-w-none text-[clamp(0.8rem,1.2vw,1.25rem)] text-center md:text-left">
            <span className="whitespace-nowrap">Web Platforms</span>
            <span className="w-1.5 h-1.5 rounded-full bg-blue-500/60 hidden sm:block"></span>
            <span className="hidden sm:inline whitespace-nowrap">Mobile Apps</span>
            {/* Mobile line break specific */}
            <span className="sm:hidden w-full h-0 basis-full"></span>
            <span className="sm:hidden whitespace-nowrap">Mobile Apps</span>
            <span className="w-1.5 h-1.5 rounded-full bg-purple-500/60 hidden sm:block"></span>
            <span className="whitespace-nowrap">AI Automations</span>
          </div>
        </div>

        {/* CTA */}
        <div className="w-full flex justify-center md:justify-start md:mt-10">
          <a
            href="#tidycall"
            className="btn-pill btn-pill--titlecase hover-animation js-hero-item w-full sm:w-auto min-w-[160px] sm:min-w-[180px] flex justify-center items-center py-4 px-6 text-lg self-center md:self-start mb-4 md:mb-0"
          >
            Start Your Project
          </a>
        </div>
      </div>
    </div>
  );
};

export default HeroText;
